import React, {  useEffect, useState,useContext,useRef  } from "react";
import Lang from '../lang/translations';
import {  Link  } from "react-router-dom";
import helpersFunction from "../_helpers/helpersFunction";
import Context from '../context/context';




export default function Chat_desktop_list() {

	const country = helpersFunction.getCountry()
	const context = useContext(Context)
  const {collection_folder, default_folder} = helpersFunction.getCDNfolder()

	const [conversazioni, setConversazioni] = useState();
    const [activeTab, setActiveTab] = useState('like');
    const [transition, setTransition] = useState(false);
    const [visits, setVisits] = useState(false);
    const [like, setLike] = useState(false);

    const [visits_unreaded, setVisitsUnreaded] = useState(false);
    const [like_unreaded, setLikeUnreaded] = useState(false);


    const touchStartX = useRef(null);
  const touchEndX = useRef(null);
	
	useEffect(() => {
		
		if(conversazioni){
			getMessages()
			
		}
	},[context.nuovoMessaggio]);


	useEffect(() => {  
    
		getMessages();
   },[]);

   
  function contaNonLette(mi_piace,visite){
    var visite_non_lette = 0
    var like_non_letti = 0

    for(let i=0;i<visite.length;i++){
      if(visite[i].letto == false){
        visite_non_lette = visite_non_lette + 1
      }
    }

    for(let i=0;i<mi_piace.length;i++){
      if(mi_piace[i].letto == false){
        like_non_letti = like_non_letti + 1
      }
    }

    setVisitsUnreaded(visite_non_lette)
    setLikeUnreaded(like_non_letti)


  }


	function getMessages(){

   
		const trackerId = localStorage.getItem('trackerId');
		const token = localStorage.getItem('token');
		
		fetch(process.env.REACT_APP_APIADDRESS+"/get/notifications/"+trackerId,{ 
			method: 'get', 
			headers: {
			  'Authorization': 'Bearer '+ token
			}
		})
			.then(response => response.json())
			.then(data => {
             if(Object.keys(data).length !== 0){

              const mi_piace = data.messages.filter(item => item.type === 'like')
              const visite = data.messages.filter(item => item.type === 'visita')

              contaNonLette(mi_piace,visite)
              
              setLike(mi_piace)
              setVisits(visite)
              
            }
                
				//setConversazioni(data.messages)
				
			})
      .catch(err => {
        helpersFunction.logToBackend("E R R O R create list notifiche like",{err:err}) 
      })
  	}

      const handleTabClick = (tab) => {
        
       /* if (tab !== activeTab) {
          setTransition("transition_"+tab);
          setTimeout(() => {
            setActiveTab(tab);
            setTransition(false);
          }, 300);
        }*/
      };


      const FuocoMatch = () => {
        return (
          <svg
            width="20px"
            height="20pxpx"
            viewBox="-33 0 255 255"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            preserveAspectRatio="xMidYMid"
          >
            <defs>
              <style>
                {`
                  .cls-3 {
                    fill: url(#linear-gradient-1);
                  }
                  .cls-4 {
                    fill: #fc9502;
                  }
                  .cls-5 {
                    fill: #fce202;
                  }
                `}
              </style>
              <linearGradient id="linear-gradient-1" gradientUnits="userSpaceOnUse" x1="94.141" y1="255" x2="94.141" y2="0.188">
                <stop offset="0" stopColor="#ff4c0d" />
                <stop offset="1" stopColor="#fc9502" />
              </linearGradient>
            </defs>
            <g id="fire">
              <path
                d="M187.899,164.809 C185.803,214.868 144.574,254.812 94.000,254.812 C42.085,254.812 -0.000,211.312 -0.000,160.812 C-0.000,154.062 -0.121,140.572 10.000,117.812 C16.057,104.191 19.856,95.634 22.000,87.812 C23.178,83.513 25.469,76.683 32.000,87.812 C35.851,94.374 36.000,103.812 36.000,103.812 C36.000,103.812 50.328,92.817 60.000,71.812 C74.179,41.019 62.866,22.612 59.000,9.812 C57.662,5.384 56.822,-2.574 66.000,0.812 C75.352,4.263 100.076,21.570 113.000,39.812 C131.445,65.847 138.000,90.812 138.000,90.812 C138.000,90.812 143.906,83.482 146.000,75.812 C148.365,67.151 148.400,58.573 155.999,67.813 C163.226,76.600 173.959,93.113 180.000,108.812 C190.969,137.321 187.899,164.809 187.899,164.809 Z"
                className="cls-3"
                fillRule="evenodd"
              />
              <path
                d="M94 .000254 .812 C58 .101254 .81229 .711225 .71129 .189 .81129 .81129 Z"
                className="cls-4"
                fillRule="evenodd"
              />
              <path
                d="M95 .183812 C104 .25018381220094122312C123824239041112121254812C77 .879254 .81129Z"
                className="cls-5"
                fillRule="evenodd"
              />
            </g>
          </svg>
        );
      };
    

      function handleImageError(event,profiloAttuale) {
        console.log("Errore immagine",event.target.src)
        fetch(process.env.REACT_APP_DISPENSER+"/"+profiloAttuale+"/"+country+"/"+context.user_info.cerco)
          .then(response => response.json())
          .then(data => {
    
            if(data.length > 0){
            const main_image = data[0].default_photo.startsWith("https://") ? data[0].default_photo : process.env.REACT_APP_CDN+"/"+default_folder+"/" + profiloAttuale + ".jpg"
            
              event.target.src = main_image
            }
            
    
          });
    
      }


	function CreaElemento(messaggio,index){
   
		var time = new Date(messaggio.time);
		var time = time.getHours() + ":" + (time.getMinutes()<10?'0':'') + time.getMinutes();
		var url = "";
		
		var messaggioDaVisualizzare = "";
		
		if(context.premiumLevel == 0){
			messaggioDaVisualizzare = messaggio.blurredMessage ? messaggio.blurredMessage : messaggio.msg
		}else{
			messaggioDaVisualizzare = messaggio.msg;
		}
		
		if(messaggioDaVisualizzare.length > 25){
			messaggioDaVisualizzare = messaggioDaVisualizzare.substring(0, 25) + "\u2026"
		}else{
			messaggioDaVisualizzare = messaggioDaVisualizzare.substring(0, 25) 
		}
		
        url = "/user/"+messaggio.angelId;
		
        if(messaggio.type == "like"){
            //style={{filter : 'blur(0.5rem)'}}
            //className='blurry-text'
            return (<Link to={url} key={index} onClick={()=>segnaComeLetto(messaggio.angelId)}>
                    <li id="single_chat" >
                        
                      <div className="a clearfix">
                        <div>

                          <img onError={(e) => handleImageError(e,messaggio.angelId)}  src={process.env.REACT_APP_CDN+"/"+default_folder+"/"+messaggio.angelId+".jpg"} alt=""  width={170} height={110} />
                        </div>  
                        <div>
                          <span >{messaggio.screenName}</span>
                        </div>
                        <div className="last-message text-muted">
                                {stampaMessaggio(messaggio,messaggioDaVisualizzare)}
                                <><span className="listaMessaggi">
                              
                              {messaggio.type == "like" && messaggio.categoriaNotifica != "risposta_a_like"  && (<svg style={{marginRight:'5px'}} width="20" height="20" viewBox="0 0 512 512" fill="#dc3545"><path  d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"/></svg>)}
                              {messaggio.type == "like" && messaggio.categoriaNotifica == "risposta_a_like" && (<FuocoMatch/>)}
                                
                              {messaggio.letto && messaggio.categoriaNotifica != "risposta_a_like"  &&  (<Lang w={"hai_ricevuto_like"} page={"create_list"}/>)}
                              {!messaggio.letto && messaggio.categoriaNotifica != "risposta_a_like"  &&  (<strong><span style={{color:'#111'}}><Lang w={"hai_ricevuto_like"} page={"create_list"}/></span></strong>)}

                              {messaggio.letto && messaggio.categoriaNotifica == "risposta_a_like"  &&  (<Lang w={"ha_rispost_like"} page={"create_list"}/>)}
                              {!messaggio.letto && messaggio.categoriaNotifica == "risposta_a_like"  &&  (<strong><span style={{color:'#111'}}><Lang w={"ha_rispost_like"} page={"create_list"}/></span></strong>)}
                                
                                </span></>
                              
                          <div className="time">
                            <p>
                              <small>{time}</small>
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </Link>)
		    }


        if(messaggio.type == "visita"){
            return (<Link to={url} key={index} onClick={()=>segnaComeLetto(messaggio.angelId)}>
                <li id="single_chat" >
                    
                  <div className="a clearfix">
                    <div>
                      <img  src={process.env.REACT_APP_CDN+"/"+default_folder+"/"+messaggio.angelId+".jpg"} alt=""  width={170} height={110} />
                    </div>  
                    <div>
                     {messaggio.screenName}
                    </div>
                    <div className="last-message text-muted">
                            {stampaMessaggio(messaggio,messaggioDaVisualizzare)}
                          {messaggio.type == "visita" && (<><i class="far fa-eye red" style={{marginRight:'5px'}}></i> 
                            <span className="listaMessaggi">
                              {messaggio.letto == true ? (<Lang w={"hai_ricevuto_visita"} page={"create_list"}/>) : (<strong><span style={{color:'#111'}}><Lang w={"hai_ricevuto_visita"} page={"create_list"}/></span></strong>)}
                            </span></>)}
                         
                          
                      <div className="time">
                        <p>
                          <small>{time}</small>
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </Link>)
        }

		
	}
	

    function DisplayConversazioniPrecedenti(lista){
      
		let tempConversazioni = [];
		if(lista.elements?.length > 0){


			for(let i=0;i<lista.elements.length;i++){
				tempConversazioni.push(CreaElemento(lista.elements[i],i))
			}

			
		
			return (<div>{tempConversazioni}</div>)
		}else{
			return (<div className="notification_content no_content" id="chatHeight">
                <div className="text-center absolute_icebreaker">
                    
                    <p><Lang w={"nessuna_notifica"} page={"create_list"}/></p>
                   
                </div>
            </div>)
		}
	}

  function segnaComeLetto(angelId){

    const trackerId = localStorage.getItem('trackerId');
    const token = localStorage.getItem('token');
    const url = process.env.REACT_APP_APIADDRESS+"/log/notification/readed"
    
    fetch(url,{ 
        method: 'POST', 
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
          },
        body:JSON.stringify({clickid:trackerId,angelId:angelId})
      })
      .then(response => response.json())
      .then(data => {
    });
  }
	
	function stampaMessaggio(messaggio,messaggioDaVisualizzare){
		var renderMessaggio = ""
		if(!messaggio.letto){
			renderMessaggio = messaggio.idNotifica == "benvenuto" ? (<p className="nonLetto listaMessaggi" dangerouslySetInnerHTML={{__html: messaggioDaVisualizzare}}></p>) : (<p className="nonLetto listaMessaggi">{messaggioDaVisualizzare}</p>)
		}
		if(messaggio.letto){
			renderMessaggio = messaggio.idNotifica == "benvenuto" ? (<p className="listaMessaggi" dangerouslySetInnerHTML={{__html: messaggioDaVisualizzare}}></p>) : (<p className="listaMessaggi">{messaggioDaVisualizzare}</p>)
		}
		if(messaggio.type == "like"){

		}
		return renderMessaggio
	}


    useEffect(() => {
       /* const contentElement = document.querySelector('.notification_content');
    
        contentElement.addEventListener('touchstart', handleTouchStart);
        contentElement.addEventListener('touchmove', handleTouchMove);
        contentElement.addEventListener('touchend', handleTouchEnd);
    
        return () => {
          contentElement.removeEventListener('touchstart', handleTouchStart);
          contentElement.removeEventListener('touchmove', handleTouchMove);
          contentElement.removeEventListener('touchend', handleTouchEnd);
        };*/
      }, [activeTab]);

	
    const handleTouchStart = (e) => {
        touchStartX.current = e.targetTouches[0].clientX;
      };
    
      const handleTouchMove = (e) => {
        touchEndX.current = e.targetTouches[0].clientX;
      };
    
      const handleTouchEnd = () => {
        if (touchStartX.current - touchEndX.current > 50) {
          // Swipe da destra a sinistra
          if(activeTab == "like"){
            handleTabClick('visit');
          }else{
            return
          }
         
        }
    
        if (touchEndX.current - touchStartX.current > 50) {
          // Swipe da sinistra a destra
          if(activeTab == "visit"){
            handleTabClick('like');
          }else{
            return
          }
        }
      };
	
	
	
	return (<> <div className="tabs_notifiche">
       
        <div  className={`tab ${activeTab === 'like' ? 'bb_2' : '' + visits.length == 0 ? 'w100' : ''} `}  onClick={() => handleTabClick('like')}>
            <div className="tab_container">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#797777" viewBox="0 0 512 512"><path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"/></svg>
                
                <span><Lang w={"mi_piace"} page={"create_list"}/>
                <span class="badge badge-danger navMob">{like_unreaded}</span>
                </span>
            </div>
        </div>
        {visits.length > 0 && (
          <div className={`tab ${activeTab === 'visit' ? 'bb_2' : ''}`}  onClick={() => handleTabClick('visit')}>
          <div className="tab_container">
              <i className="far fa-eye"></i>
              <span>Visite</span>
              <span style={{left: '69px'}} class="badge badge-danger navMob">{visits_unreaded}</span>
          </div>
      </div>
        )}
        
      </div>
      <div className={`notification_content ${transition ? transition : ''}`}>
        {activeTab === 'visit' ? (
          <ul className="friend-list d-lg-block">
            
              <DisplayConversazioniPrecedenti elements={visits}/>
           
          </ul>
        ) : (
            <ul className="friend-list d-lg-block">
           
               <DisplayConversazioniPrecedenti  elements={like}/>
            
          </ul>
        )}
      </div>
      </>);
	
	
}